module.exports = __webpack_public_path__ + "img/copy-seven.ec81536b.svg";